import React from "react";
import PropTypes from "prop-types";
import {
  Panel,
  PanelHeader,
  PanelHeaderButton,
  Group,
  FormLayout,
  Input,
  Button,
  Cell,
  ScreenSpinner,
  Alert,
  FormStatus,
} from "@vkontakte/vkui";
import { platform, IOS } from "@vkontakte/vkui";
import Icon28ChevronBack from "@vkontakte/icons/dist/28/chevron_back";
import Icon24Back from "@vkontakte/icons/dist/24/back";
import emailValidator from "../validators/emailValidator";
import phoneValidator from "../validators/phoneValidator";
import "../css/main.css";
import { useHistory } from "react-router-dom";

document.addEventListener("DOMContentLoaded", ready);
let count = 0;

function ready() {
  // console.warn("ready");
  const elementBack = document.getElementsByClassName("PanelHeader__left")[1];
  elementBack.setAttribute("style", "display: none");

  const iframe = document.getElementById("iframe-wg");
  // console.warn(iframe);

  document.getElementById("iframe-wg").addEventListener("load", (e) => {
    // console.log('load.......');
    // console.log(e);
    // console.log('count ' , count);

    if (count == 0){
      const elementBack = document.getElementsByClassName("PanelHeader__left")[1];
      elementBack.setAttribute("style", "display: none");
    } else {
      const elementBack = document.getElementsByClassName("PanelHeader__left")[1];
      elementBack.setAttribute("style", "display: block");
    }
    count++;
  });

  // console.warn(document.getElementsByTagName('button'));
}

const Home = ({ id, wType, w, title, platform }) => (
  <Panel id={id}>
    <PanelHeader hidden={wType !== "schedule"}>{title}</PanelHeader>
    <PanelHeader
      hidden={wType !== "payment"}
      left={
        <PanelHeaderButton
          onClick={() => {
            window.location.reload();
          }}
        >
          {platform === "iphone" ? <Icon28ChevronBack /> : <Icon24Back />}
        </PanelHeaderButton>
      }
    >
      {title}
    </PanelHeader>

    <iframe
      id="iframe-wg"
      src={`https://wg.sportpriority.com/${wType}?w=${w}&isMiniApp=${
        // src={`http://localhost:4201/${wType}?w=${w}&isMiniApp=${
        platform == "android" || platform == "iphone"
      }&isVkLoader=${true}`}
    ></iframe>
  </Panel>
);

Home.propTypes = {
  id: PropTypes.string.isRequired,
  fetchedUser: PropTypes.shape({
    photo_200: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    city: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

export default Home;
